// extracted by mini-css-extract-plugin
export default {"transferWrap":"Resend_transferWrap__EZdc2"};